// Core
import { call, put } from 'redux-saga/effects';

// Instruments
import { compareActions as actions } from 'bus/compare/actions';
import { compareStorage as storage } from 'bus/compare/storage';

export function* removeFromCompareWorker ({ payload: offerId }) {
    try {
        if (!offerId) {
            throw new Error('Wrong offer id');
        }

        yield call([storage, 'set'], offerId, null);
        yield put(actions.removeFromCompareSuccess());
    } catch (error) {
        yield put(actions.removeFromCompareFail(error));
    }
}
